import SelectOrg from './SelectOrg';

$(document).ready(() => {
    if ($('body').attr('id') !== 'feide:selectorg') {
        return;
    }
    // eslint-disable-next-line no-new
    new SelectOrg();
});
